<template>
  <div>
    <div :id="VIEW_LIST" v-if="viewType == VIEW_LIST">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
                <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                  <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                    <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                    <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                    <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                    <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                    <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                  </select>
                </div>          
                <div class="box-tools">              
                  <button v-on:click="onCreate" class="btn btn-primary">Create</button>
                  <button v-on:click="inquiry" class="btn btn-warning">Search</button>
                </div>
            </div>        
            <div class="box-body no-padding table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 45px;text-align:right;">#</th>
                    <th style="text-align:center;">Action</th>
                    <th style="text-align:left;">Name</th>
                    <th style="text-align:center;">Bar/Restaurant</th>
                    <th style="text-align:left;">Project</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                    <td style="width:85px;text-align:center;">
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>
                      <a href="#" v-on:click="onEdit(row)" ref="editRow" style="padding-right:5px">
                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                      </a>
                      <a href="#" v-on:click="onDelete(row)" ref="deleteRow" style="padding-right:5px">
                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                      </a>
                    </td>
                    <td style="text-align:left;">{{ row.name }}</td>
                    <td style="text-align:center;"><input type="checkbox" :checked= row.isBarRestaurant> </td>
                    <td style="text-align:left;">{{ row.projectName }}</td>
                    <td hidden>{{ row.projectId }}</td>                   
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                    <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>
                    Page
                </label>
                <label>
                    <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">
                  {{ totalPages }}                
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                    <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div :id="VIEW_FORM" v-if="viewType == VIEW_FORM">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box box-info">
              <form @submit.prevent class="form-horizontal">
                <div class="box-body">
                  <div class="form-group">
                    <div class="col-md-5">                    
                      <div>
                        <label for="inputName">Name</label>
                        <h1 style="margin-top:0px;">
                          <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Product Name" v-model="formData.name">
                        </h1>                        
                      </div>                                          
                    </div>                    
                  </div>
                  <div class="form-group">
                    <div class="col-sm-offset-2 col-sm-10">
                      <div class="checkbox">
                        <label>
                          <input type="checkbox" @click="onClickBarRestaurant()" :checked="formData.isBarRestaurant">Is a Bar/Restaurant
                        </label>
                      </div>                                         
                    </div>
                    <div class="col-md-6">                     
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-md-6">
                      <label for="inputProject" class="col-sm-4 control-label">Project</label>
                      <div class="col-sm-8">
                        <select v-model="formData.projectId" class="form-control" :disabled="viewMode == MODE_VIEW">
                          <option v-for="(row, i) in listProjectForm" v-bind:key="i" v-bind:value="row.id">
                            {{ row.name }}
                          </option>
                        </select>
                      </div>                                        
                    </div>
                    <div class="col-md-6">
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-md-6">
                      <label for="comboProductCategory" class="col-sm-4 control-label">Product Category</label>
                      <div class="col-sm-8">
                        <select2 :id="'comboProductCategory'" :options="listProductCategory" :value="productCategorySelected" :enable="false">
                        </select2>                          
                      </div>                                       
                    </div>
                    <div class="col-md-6">
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-md-6">
                      <label for="comboCashier" class="col-sm-4 control-label">Cashier</label>
                      <div class="col-sm-8">
                        <select2 :id="'comboCashier'" :options="listCashier" :value="cashierSelected">
                        </select2>                          
                      </div>                                                            
                    </div>
                    <div class="col-md-6">
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="col-md-6">
                      <label for="comboPaymentMethod" class="col-sm-4 control-label">Payment Method</label>
                      <div class="col-sm-8">
                        <select2 :id="'comboPaymentMethod'" :options="listPaymentMethod" :value="paymentMethodSelected">
                        </select2>                          
                      </div>                                                            
                    </div>
                    <div class="col-md-6">
                    </div>
                  </div>                  
                  <input type="hidden" class="form-control" id="inputProjectId" v-model="formData.projectId">
                </div>

                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancel()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button>
                  </div>
                </div>

              </form>
            </div>          
          </div>
        </div>
      </div> 
    </transition>  
  </div>  
</template>

<script>
import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'
import select2 from '../../components/widgets/Select2'

const VIEW_LIST = 'list'
const VIEW_FORM = 'form'
const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'

export default {
  name: 'POSConfig',
  components: {
    datepicker, select2
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      VIEW_LIST: VIEW_LIST,
      VIEW_FORM: VIEW_FORM,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      listData: null,
      listDataTemp: null,
      listProject: null,
      listProjectForm: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'Name',
        WhereClauseByProject: ''
      },
      viewType: VIEW_LIST,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        isBarRestaurant: false,
        projectId: 0,
        projectName: '',
        productCategory: [],
        cashier: [],
        paymentMethod: []
      },
      listProductCategory: null,
      listProductCategoryTemp: null,
      productCategorySelected: [],
      listCashier: null,
      listCashierTemp: null,
      cashierSelected: [],
      listPaymentMethod: null,
      listPaymentMethodTemp: null,
      paymentMethodSelected: []
    }
  },
  computed: {
  },
  created() {
    this.viewType = VIEW_LIST
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    onSearch(evt) {
      var keyWords = evt.target.value
      var whereClause = ['Name', 'like', '\'%' + keyWords + '%\'']
      this.inquiryParam.WhereClause = whereClause.join(' ')
      this.inquiry()
    },
    inquiryPOS() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      var arrProject = []

      api
        .request('POS', 'get', '/api/POS/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listDataTemp = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
          this.$refs.recordPerPage.value = this.inquiryParam.PageSize

          this.listDataTemp.forEach(itemPOSConfig => {
            // Populate project
            arrProject.push(itemPOSConfig.projectId)
            var arrProjectUnique = arrProject.filter(function(item, index) {
              return arrProject.indexOf(item) >= index
            })
            arrProject = arrProjectUnique
          })
        })
        .then(response => {
          // Get project
          if (arrProject.length === 0) {
            return
          }
          let whereClause = 'id in (' + arrProject.join(',') + ')'
          api
            .request('Account', 'get', '/api/Project/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrProject.length +
                                          '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
            .then(response => {
              var data = response.data
              this.listProject = data.entity

              var projectName
              this.listDataTemp.forEach(itemPOSConfig => {
                projectName = ''
                this.listProject.some(function(itemProject, index) {
                  if (itemPOSConfig.projectId === itemProject.id) {
                    projectName = itemProject.name
                  }
                })
                itemPOSConfig.projectName = projectName
              })
              this.listData = this.listDataTemp
            })
            .catch(error => {
              var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
              SweetAlert.fire('Error', message, 'error')
            })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    inquiry() {
      this.inquiryPOS()
      this.getMasterData()
      // var thiss = this
      // let p1 = new Promise((resolve, reject) => {
      //   thiss.getMasterData()
      //   setTimeout(resolve, 0)
      // })

      // p1.then(() => {
      //   thiss.inquiryPOS()
      // })
    },
    getProject() {
      api
        .request('Account', 'get', '/api/Project/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listProjectForm = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getProductCategory() {
      api
        .request('Sales', 'get', '/api/ProductCategory/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listProductCategoryTemp = data.entity
          this.listProductCategory = []
          this.listProductCategoryTemp.forEach(item => {
            let objProductCategory = {
              id: item.id,
              text: item.name
            }
            this.listProductCategory.push(objProductCategory)
          })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCashier() {
      api
        .request('Account', 'get', '/api/Account/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listCashierTemp = data.entity
          this.listCashier = []
          this.listCashierTemp.forEach(item => {
            let objCashier = {
              id: item.id,
              text: item.name
            }
            this.listCashier.push(objCashier)
          })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getPaymentMethod() {
      api
        .request('POS', 'get', '/api/PaymentMethod/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listPaymentMethodTemp = data.entity
          this.listPaymentMethod = []
          this.listPaymentMethodTemp.forEach(item => {
            let objPaymentMethod = {
              id: item.id,
              text: item.name
            }
            this.listPaymentMethod.push(objPaymentMethod)
          })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getMasterData() {
      this.getProject()
      this.getProductCategory()
      this.getCashier()
      this.getPaymentMethod()
    },
    initForm() {
      this.formData.id = 0
      this.formData.name = ''
      this.formData.isBarRestaurant = false
      this.formData.projectId = 0
      this.formData.projectName = ''
    },
    onCreate() {
      this.initForm()
      this.viewType = VIEW_FORM
      this.viewMode = MODE_CREATE
    },
    onClickBarRestaurant() {
      if (this.viewMode === MODE_UPDATE) {
        this.formData.isBarRestaurant = !this.formData.isBarRestaurant
      }
    },
    showForm(row, viewMode) {
      api
        .request('POS', 'get', '/api/POS/GetDetail?Id=' + row.id, null)
        .then(response => {
          var data = response.data
          this.formData.id = data.entity.id
          this.formData.name = data.entity.name
          this.formData.isBarRestaurant = data.entity.isBarRestaurant
          this.formData.projectId = data.entity.projectId
          this.formData.productCategory = data.entity.productCategory
          this.formData.cashier = data.entity.cashier
          this.formData.paymentMethod = data.entity.paymentMethod

          let productCategorySelected = this.productCategorySelected = []
          this.formData.productCategory.forEach(element => {
            productCategorySelected.push(element.productCategoryId)
          })
          let cashierSelected = this.cashierSelected = []
          this.formData.cashier.forEach(element => {
            cashierSelected.push(element.cashierId)
          })
          let paymentMethodSelected = this.paymentMethodSelected = []
          this.formData.paymentMethod.forEach(element => {
            paymentMethodSelected.push(element.paymentMethodId)
          })
        })
        .then(response => {
          this.viewType = VIEW_FORM
          this.viewMode = viewMode
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onDisplay(row) {
      this.showForm(row, MODE_VIEW)
    },
    onEdit(row) {
      this.showForm(row, MODE_UPDATE)
    },
    onDelete(data) {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.delete(data)
          SweetAlert.fire('Deleted', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
        }
      })
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      this.inquiry()
      this.viewType = VIEW_LIST
    },
    onSave() {
      var pointOfSalesId = this.formData.id
      var arrProductCategorySelected = $('#comboProductCategory').val()
      var arrCashierSelected = $('#comboCashier').val()
      var arrPaymentMethodSelected = $('#comboPaymentMethod').val()

      var lstProductCategorySelected = []
      if (arrProductCategorySelected) {
        arrProductCategorySelected.forEach(element => {
          var objProductCategory = {
            Id: 0,
            ProductCategoryId: JSON.parse(element),
            PointOfSalesId: pointOfSalesId
          }
          lstProductCategorySelected.push(objProductCategory)
        })
      }

      var lstCashierSelected = []
      if (arrCashierSelected) {
        arrCashierSelected.forEach(element => {
          var objCashier = {
            Id: 0,
            CashierId: JSON.parse(element),
            PointOfSalesId: pointOfSalesId
          }
          lstCashierSelected.push(objCashier)
        })
      }

      var lstPaymentMethodSelected = []
      if (arrPaymentMethodSelected) {
        arrPaymentMethodSelected.forEach(element => {
          var objPaymentMethod = {
            Id: 0,
            PaymentMethodId: JSON.parse(element),
            PointOfSalesId: pointOfSalesId
          }
          lstPaymentMethodSelected.push(objPaymentMethod)
        })
      }

      var data = {
        Id: this.formData.id,
        Name: this.formData.name,
        IsBarRestaurant: this.formData.isBarRestaurant,
        ProjectId: this.formData.projectId,
        ProductCategory: lstProductCategorySelected,
        Cashier: lstCashierSelected,
        PaymentMethod: lstPaymentMethodSelected
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('POS', 'post', '/api/POS/' + method, data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity

          if (resData.returnStatus) {
            this.onDisplay({id: this.formData.id, name: this.formData.name})
          }

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    delete(data) {
      var status = ''
      var message = ''
      var reqData = {
        Id: data.id,
        Name: data.name
      }
      api.request('POS', 'post', '/api/POS/Delete', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.inquiry()
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}
</style>



// WEBPACK FOOTER //
// POSConfig.vue?5ed19407